document.addEventListener('DOMContentLoaded', () => {
  const barSection = document.querySelector('.moko-tracker-buy-now-bar-section');
  const main = document.querySelector('#main');
  const firstSection = main?.querySelector(':scope > .shopify-section:first-child');
  const footer = document.querySelector('.footer');

  if (!barSection || !firstSection) return;

  let sectionScrolledPast = false;
  let footerVisible = false;

  const updateVisibility = () => {
    barSection.classList.toggle('is-visible', sectionScrolledPast && !footerVisible);
  };

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      sectionScrolledPast = entry.intersectionRatio < 0.5;
      updateVisibility();
    });
  }, { threshold: [0, 0.5, 1] });

  sectionObserver.observe(firstSection);

  if (footer) {
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        footerVisible = entry.isIntersecting;
        updateVisibility();
      });
    }, { threshold: 0 });

    footerObserver.observe(footer);
  }
});
